import BASE_RULE from '../baseRule';
import {VisualType, SearchTypeVisual} from './constants';
import {VisualRule} from './types';

export const visualRuleDefaults: VisualRule<VisualType.ASSET> = {
	...BASE_RULE,
	elementType: SearchTypeVisual,
	elementSubType1: VisualType.ASSET,
	elementValue1: 0,
};

export default visualRuleDefaults;
